import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { LearnedPresetKind } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries["used-parcel-learning"];

export const UsedParcelLearningColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.CENTER,
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
  renderNormalCell: ({ row }) => {
    const usedLearning = row.usedLearning?.[LearnedPresetKind.PARCEL] || false;
    return <RedoTableTextCell text={usedLearning ? "Yes" : "No"} />;
  },
};
